import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CityModel } from 'projects/Administration/src/app/business-entities/customer-view.model';
import { CustomerService } from '../../../../business-services/customer.service';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { Address } from 'projects/Widget/src/app/business-entities/address-model';
import { CountryNameAndMobileCode } from 'projects/Widget/src/app/business-entities/country-name-and-mobile-code.interface';
import { CreateContactRequestModel } from 'projects/Widget/src/app/business-entities/create-contact-request-model';
import { FindCarService } from 'projects/Widget/src/app/business-services/find-car.service';
import { CommonService } from 'projects/Widget/src/app/services/commom.service';
import { CultureLocaleService } from 'projects/Widget/src/app/services/culture-locale.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { CountryISO } from 'ngx-intl-tel-input-gg';

@Component({
  selector: 'app-add-contact',
  templateUrl: './add-contact.component.html'
})
export class AddContactComponent implements OnInit {

  contactDetailsForm: FormGroup;
  countryDropdown: CountryNameAndMobileCode[] = [];
  cityList: CityModel[];
  postCodeList: any;
  postCodeRawData: any;
  userInputMobilecode?: string = '';
  appData: any;
  CountryISO = CountryISO;
  isInitialLoad: boolean= true;
  onlyCountries: string[] = [];
  countryDialCodes: any[]= [];
  selectedCountryISO= this.cultureLocaleService.getLocale() || CountryISO.Norway;
  
  @Input() mobileCode: string;
  @Input() mobileNo: string;

  constructor(public activeModal: NgbActiveModal,
    private fcService: FindCarService,
    private cultureLocaleService: CultureLocaleService,
    private cdref: ChangeDetectorRef,
    private commonService: CommonService,
    private service: CustomerService,
    private translate: TranslateService,
    private toaster: ToastrService,
    private spinner: NgxSpinnerService,
    private secureStorage: SecureStorage
  ) { }

  ngOnInit(): void {
    this.onlyCountries= Constant.OnlyCountry;
    this.countryDialCodes= Constant.CountryDialCodes;
    this.initializeContactForm();
    this.countryDropdownDetails();
    this.appData = this.commonService.getAppData();
    this.getPostCodeDropdown();
  }

  initializeContactForm() {
    this.contactDetailsForm = new FormGroup({
      FirstName: new FormControl(null, [Validators.required, Validators.pattern(/^[A-Za-z ]*$/)]),
      LastName: new FormControl(null, [Validators.required, Validators.pattern(/^[A-Za-z ]*$/)]),
      Email: new FormControl(null, [Validators.required, Validators.pattern(/^\w+(?:[.-]\w+)*@\w+(?:[.-]\w+)*(?:\.\w{2,3})+$/)]),
      //Email: new FormControl(null, [Validators.required, Validators.pattern(/^\w+(?:[\.-]\w+)*@\w+(?:[\.-]\w+)*(?:\.\w{2,3})+$/)]),
      Address1: new FormControl(null, [Validators.required]),
      Address2: new FormControl(null),
      City: new FormControl(null, [Validators.required]),
      CountryId: new FormControl(null, [Validators.required]),
      Zipcode: new FormControl(null, [Validators.required]),
      MobileNo: new FormControl(this.mobileNo, [Validators.required])
    })
  }

  get ContactFormControls(): any {
    return this.contactDetailsForm.controls;
  }

  async countryDropdownDetails(): Promise<void> {
    this.spinner.show();
    await this.fcService.getCountryCodeAndMobileCodeDetails()
      .then((result) => {
        this.spinner.hide();
          this.countryDropdown =  result.responseObject.result.filter(x => x.isDisplay);
      });
  }

  BindPostData(city) {
    if (city) {
      this.postCodeList = this.postCodeRawData.filter(f => f.city == city);
      this.contactDetailsForm.patchValue({
        Zipcode : this.postCodeList[0].code,
        City : city,
        CountryId : this.countryDropdown[0].id
      })
    } else {
      this.postCodeList = this.postCodeRawData;
    }
  }

  BindCityData(post) {
    if (post) {
      let postdata = this.postCodeRawData.filter(f => f.code == post);
      this.cityList = postdata.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
      this.contactDetailsForm.patchValue({
        Zipcode : post,
        City : this.cityList[0],
        CountryId : this.countryDropdown[0].id
      })
    } else {
      this.cityList = this.postCodeRawData.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
    }
  }

  async onCitySelected(city: string) {
    this.service.customerListRequest.city = city;
    if (city) {
      this.BindPostData(city);
    } else {
      this.cityList = this.postCodeRawData.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
      this.service.customerListRequest.postCode = "";
      this.contactDetailsForm.patchValue({
        Zipcode : null,
        CountryId : null
      })
      this.postCodeList = this.postCodeRawData;
    }
  }

  async onPostCodeSelected(postCode: string) {
    this.service.customerListRequest.postCode = postCode;
    if (postCode) {
      this.BindCityData(postCode);
    } else {
      this.postCodeList = this.postCodeRawData;
      this.service.customerListRequest.city = "";
      this.contactDetailsForm.patchValue({
        City : null,
        CountryId : null
      })
      this.cityList = this.postCodeRawData.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
    }
  }

  onCountryChange(obj) {
    if (this.isInitialLoad) {
    this.telInputObject();
    this.userInputMobilecode = this.userInputMobilecode || obj.dialCode;
    this.isInitialLoad = false;
    } else {
      this.userInputMobilecode = obj.dialCode;
    }
    this.commonService.addUserAuthMobileCode( this.userInputMobilecode);
    if(this.appData.customerDetails)
     {
      this.appData.customerDetails.mobileCode = this.userInputMobilecode;
     }
  }

  isDigit(event): void {
    const isDigit = Utility.isDigit(event);
    if (!isDigit) {
      event.preventDefault();
    }
  }

  telInputObject() {    
    if(this.userInputMobilecode)
    {
      let countryCode = this.getCountryCodeByDialCode(this.userInputMobilecode);
      this.selectedCountryISO= countryCode?countryCode:this.cultureLocaleService.getLocale();
    }
    else {
      let countryCode = this.getCountryCodeByDialCode(this.mobileCode);
      this.selectedCountryISO= countryCode?countryCode:this.cultureLocaleService.getLocale();
    }
  }

  getCountryCodeByDialCode(dialCode: any) {
    const country = this.countryDialCodes.find(c => c.dialCode === dialCode);
    return country ? country.countryCode : null;
  }

  async getPostCodeDropdown() {
    this.spinner.show();
    let postCodes = this.secureStorage.getKeyData('postCodes');
    if (postCodes) {
      this.postCodeRawData = postCodes;
      this.BindPostData("");
      this.BindCityData("");
    } 
    this.spinner.hide();
  }

  onContactFormSubmit() {
    let contactInfo: CreateContactRequestModel = {
      accountId: '',
      countryCode: 'FI',
      email: this.contactDetailsForm.get('Email').value,
      firstName: this.contactDetailsForm.get('FirstName').value,
      lastName: this.contactDetailsForm.get('LastName').value,
      mobilePhone: this.contactDetailsForm.get('MobileNo').value,
      customerGroup: '',
      address: this.fillAddressModel()
    }

    let errorMessage = this.translate.instant("lblErrorMessage");
    let WarningMessage = this.translate.instant("lblErrorWarningForValue")

    let successMessage = "";
    successMessage = this.translate.instant("lblContactAddedSuccessfully");
    this.spinner.show();
    this.fcService.CreateContact(contactInfo).then((response) => {
      if(response.responseObject) {
        this.appData.driverId = response.responseObject.result.dataObject;
        this.fcService.AssignDriverToVehicle(this.commonService.vehicleId, this.appData.driverId)
          .then((_result) => {
            // This is intentional
          },
          (_err) => {
            // This is intentional
          });
      }
    },
    (error) => {
      this.spinner.hide();
      if (error.status === Constant.BadRequest) {
        this.toaster.warning(WarningMessage);
      }
      else {
        this.toaster.error(errorMessage);
      }
    });
  }

  fillAddressModel(): Address {
    let addressInfo: Address = {
      street1: this.contactDetailsForm.get('Address1').value,
      street2: this.contactDetailsForm.get('Address2').value,
      street3: '',
      city: this.contactDetailsForm.get('City').value,
      postalCode: this.contactDetailsForm.get('Zipcode').value
    }
    return addressInfo;
  }

  empty(e: any) {
    switch (e) {
      case "":
      case null:
      case undefined:
        return true;
      default:
        return false;
    }
  }

}
